import { connect } from 'react-redux';
import type { ValuationPERatioProps } from '@/pages/CompanyReport/components/Value';
import { ValuationPERatioRawData } from '@/pages/CompanyReport/components/Value';
import {
  getAnalysis,
  getFormatting,
  getSummary,
} from '@/pages/CompanyReport/redux/selectors';
import { getAveragesSelector } from '@ducks/averages/selectors';
const mapStateToProps = (
  state,
  ownProps: { companyId?: string }
): ValuationPERatioProps => {
  const summary = getSummary(state, ownProps);
  const analysis = getAnalysis(state, ownProps);
  const formatting = getFormatting(state, ownProps);
  const { getIndustryAverage, getMarketAverage } = getAveragesSelector(
    state,
    ownProps
  );
  const industryPE = getIndustryAverage('PE');
  const marketPE = getMarketAverage('PE');
  return {
    uniqueSymbol: summary.uniqueSymbol,
    lastEarningsUpdate: analysis.lastEarningsUpdateTimeStamp,
    reportingCurrencyISO: formatting.reportingCurrencyISO,
    reportingCurrencySymbol: formatting.reportingCurrencySymbol,
    primaryTradingCurrencySymbol: formatting.primaryTradingItemCurrencySymbol,
    primaryTradingCurrencyISO: formatting.primaryTradingItemCurrencyISO,
    isExchangeRateNeeded: formatting.isExchangeRateNeeded,
    exchangeRate: formatting.exchangeRate,
    peValue: analysis.PE,
    earningsPerShare: analysis.EPS,
    exchangeSymbol: summary.exchangeSymbol,
    tickerSymbol: summary.tickerSymbol,
    latestPriceDate: analysis.eodPriceUpdateTimeStamp,
    primaryPrice: analysis.primaryPrice,
    primaryCurrencyReported: analysis.primaryCurrencyReported,
    industryCountryName: industryPE.source,
    industrySecondaryName: summary.industryData.secondaryName,
    industryAveragePECount: industryPE.count,
    industryAveragePE: industryPE.value,
    marketCountryName: marketPE.source,
    marketAveragePECount: marketPE.count,
    marketAveragePE: marketPE.value,
    companyShortName: summary.shortName,
  };
};

export default connect(mapStateToProps)(ValuationPERatioRawData);
